import { createDefaultFetch, IFetchStatus } from '../../types/rest/IFetchStatus';
import { ISelectOption } from '../components';

export interface IAssociatedLendersApplicationState {
  associatedLenders: IAssociatedLenders;
  associatedLendersFetchStatus: IFetchStatus;
  associatedLendersError: string | null;
  updateAssociatedLendersFetchStatus: IFetchStatus;
  updateAssociatedLendersError: string | null;
}

export const associatedLendersApplicationInitialState: IAssociatedLendersApplicationState = {
  associatedLenders: {},
  associatedLendersFetchStatus: createDefaultFetch(),
  associatedLendersError: null,
  updateAssociatedLendersFetchStatus: createDefaultFetch(),
  updateAssociatedLendersError: null,
};

export interface IAssociatedLenders {
  [clientId: string]: Array<ISelectOption<string>>;
}

export interface IClientLenderAssociationsRequest {
  lenderCompanyIdsToAdd: string[];
  lenderCompanyIdsToRemove: string[];
}
